const ServiceApi=[
  {
      id: 1,
      category: "Services",
      year: "Développement Web ",
      title: "CRÉATION DES SITES & APPLICATIONS WEB",
      desc: "On vous offre des solutions web complètes : design, responsive, rapide, hébergement, référencement, maintenance, …",
      rate: "🌐",
  },
  {
      id: 2,
      category: "Services",
      year: "Développement mobile",
      title: "APPLICATION MOBILE",
      desc: "Optimisation des conversations, accessiblilité renforcée, augmentation de la qualité des interventions.",
      rate: "📱"
  },
  {
    id: 3,
    category: "Services",
    year: "Logiciels de gestion ou de bureau ",
    title: "CONCEPTION & RÉALISATION DES LOGICIELS",
    desc: "Prise des décisions le plus possible avec des données statistiques, facilite les tâches, économiser en temps et en ressource.",
    // content: "",
    rate: "💻"
},
  {
      id: 4,
      category: "Services",
      year: "En divers domaines numériques.",
      title: "FORMATION",
      desc: " Nous organisons des sessions de formation en Programmation, en bureautique, en SEO, Design et bien d'autres.",
      rate: "👨‍🏫"
      ,
  },
  {
      id: 5,
      category: "Services",
      year: " Consulting",
      title: "AUDIT & CONSEIL",
      desc: "L’analyse, le diagnostic et les conseils vous permettront d’identifier et d’évaluer les risques associés aux activités informatiques de votre entreprise.",
      content: "Suivi régulier, écoute permanente et réponse",
      rate: "🗣",
  },
]
export default ServiceApi;
